export const GET_PRODUCTS_SUCCESS = "PRODUCTS/get/success";
export const GET_PRODUCTS_LOADING = "PRODUCTS/get/loading";
export const GET_PRODUCTS_ERROR = "PRODUCTS/get/error";

export const GET_SEARCHED = "PRODUCTS/get/search";
